export default __webpack_public_path__ + "static/media/chevron-right.c5bac346.svg";